import { useEffect, useState } from "react";
import { Send, ChevronDown, ChevronUp } from "lucide-react";
import { api, money } from "@/lib/api";
import StatusBadge from "@/components/StatusBadge";

// Repasse (Asaas) → estado do StatusBadge acessível (cor + ícone); o rótulo textual vem do backend.
const PAYOUT_TO_BADGE = {
  PAID: "pago",
  PROCESSING: "processando",
  AUTHORIZED: "processando",
  AGUARDANDO_AUTORIZACAO: "aguardando",
  AGUARDANDO_SALDO: "aguardando",
  FAILED: "cancelado",
  NOT_ELIGIBLE: "pendente",
  PENDING: "pendente",
  ENVIANDO: "processando",
  INCERTO: "aguardando",
};

function dt(s) {
  if (!s) return "";
  return new Date(s).toLocaleString("pt-BR", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" });
}

export default function MyPayouts() {
  const [rows, setRows] = useState(null);
  const [open, setOpen] = useState({});

  useEffect(() => {
    const fetchP = () => api.get("/me/payouts").then((r) => setRows(r.data)).catch(() => setRows([]));
    fetchP();
    const t = setInterval(fetchP, 15000);
    return () => clearInterval(t);
  }, []);

  if (rows === null) return null;

  return (
    <div className="bg-surface border border-border rounded-lg p-6" data-testid="my-payouts">
      <h2 className="font-head text-xl sm:text-2xl font-semibold tracking-tight flex items-center gap-2 mb-1"><Send className="h-6 w-6 text-info" />Histórico de repasses Pix</h2>
      <p className="text-[11px] text-muted-foreground mb-4">Cada tentativa de repasse do seu cachê para a sua chave Pix, com status e data.</p>
      {rows.length === 0 ? (
        <p className="text-sm text-muted-foreground py-6 text-center" data-testid="my-payouts-empty">Nenhum repasse registrado ainda. Assim que um cachê for liberado, ele aparece aqui.</p>
      ) : (
        <div className="space-y-2" data-testid="my-payouts-list">
          {rows.map((p) => (
            <div key={p.id} data-testid={`my-payout-${p.id}`} className="bg-background border border-border rounded-md p-4">
              <button onClick={() => setOpen((o) => ({ ...o, [p.id]: !o[p.id] }))} className="w-full flex items-center gap-3 text-left">
                <div className="flex-1 min-w-0">
                  <div className="font-medium truncate">{p.event_name}</div>
                  <div className="text-xs text-muted-foreground truncate">{p.instrument || "—"}{p.pix_key_masked ? ` · Pix ${p.pix_key_masked}` : ""} · {p.attempt_count} tentativa(s)</div>
                </div>
                <span className="font-mono font-semibold text-accent shrink-0">{money(p.amount || 0)}</span>
                <StatusBadge status={PAYOUT_TO_BADGE[p.status] || "pendente"} label={p.status_label} className="shrink-0" />
                {open[p.id] ? <ChevronUp className="h-4 w-4 text-muted-foreground shrink-0" /> : <ChevronDown className="h-4 w-4 text-muted-foreground shrink-0" />}
              </button>
              {open[p.id] && (
                <div className="mt-3 pl-3 border-l border-border space-y-2" data-testid={`my-payout-attempts-${p.id}`}>
                  {p.error && <div className="text-xs text-destructive">{p.error}</div>}
                  {(p.attempts || []).length === 0 ? (
                    <div className="text-xs text-muted-foreground">Sem tentativas registradas ainda.</div>
                  ) : p.attempts.map((a, i) => (
                    <div key={i} className="text-xs">
                      <div className="flex items-center gap-2">
                        <StatusBadge status={PAYOUT_TO_BADGE[a.status] || "pendente"} label={a.status_label || a.status} />
                        <span className="text-muted-foreground mono">{dt(a.at)}</span>
                      </div>
                      {a.error && <div className="text-destructive mt-0.5">{a.error}</div>}
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
